module.exports = __webpack_public_path__ + "img/content5_300_15.2584a77f.png";